<template>
    <div class="subscription left-right-layout">
      <!--  改为左右布局: pc端: 左边固定未260: 右边不变化,右边的表格宽度有个最小宽度,
移动端完全不一样,:  左边栏变成了右边出的抽屉弹框,-->
      <div class="mobile-top-bar">
        <div class="issue-box">
          <span class="issue">{{currentCycle.masterAlias}}</span>
          <span
            class="tag-box status"
            :style="getStyle(currentCycle.status)"
          >{{getStaus(currentCycle.status)}}</span>
        </div>
        <span
          class="el-icon-arrow-right"
          @click="mobileICopyHandle"
        ></span>
      </div>
      <!--没有有效订阅 todo-->
      <div
        v-if="!hasOneActiveCopy && !realMobile"
        :style="allNoOneActiveStyle"
        class="pc-no-active-subscript">
        <span>{{$t('copyMaster.No_active_subscription_yet')}},<span
          class="underline pointer"
          @click="notActiveHandle"
        >{{$t('copyMaster.Go_subscribe_now')}}</span></span>
      </div>
      <div class="layout-under-content pr"
           :class="{notActive: hasOneActiveCopy == false}"
      >
        <div class="layout-under-left hidden-xs-only">
          <div class="left-header header-top">
            <span class="title">{{$t('my_subscriptions')}}</span>

          </div>
          <sub-man-slider-bar
            ref="pcsliderbar"
            class=""
            @current-cycle="acceptCurrentCycle"
            @no-one-active="acceptNoOneActive"
          ></sub-man-slider-bar>
        </div>
        <div class="layout-under-right">
          <div class="right-header header-top">
            <span class="title">{{$t('details')}}</span>

            <div class="right-btn">
              <template
                v-if="currentCycle.status === 0"
              >
                <el-button
                  size="small"
                  type="primary"
                  @click.stop="editHandle"
                >{{$t('Edit_subscription')}}</el-button>
                <el-button
                  size="small"
                  @click.stop="cancleHandle"
                >{{$t('unsubscribe')}}</el-button>
              </template>
              <template
                v-if="currentCycle.status == 1 || currentCycle.status == 2"
              >
                <el-button
                  size="small"
                  type="primary"
                  @click.stop="copyHandle"
                >{{$t('Resubscribe')}}</el-button>
              </template>
            </div>
          </div>
          <VuePerfectScrollbar
            class="scroll-area--customizer"
            :settings="settings"
            :key="$vs.rtl"
          >
            <div class="right-content">
              <right-content
                :row-data="currentCycle"
              ></right-content>
            </div>
          </VuePerfectScrollbar>
        </div>
      </div>
<!--      移动端需要测试 todo-->
      <mobileICopySiderBar
        ref="mobilesliderbar"
        :dialog-show="mobileDialogShow"
        @close="mobileDialogShow = false"
        @current-cycle="acceptCurrentCycle"
      ></mobileICopySiderBar>
      <search-trade-dialog
        :dialog-show="searchDialogShow"
        @close="searchDialogShow = false"
      ></search-trade-dialog>
    </div>
</template>

<script>
import searchTradeDialog from "@/components/user/details/mamSub/ICopy/searchTradeDialog";
import { colorRgba } from '@/utils'
import { mapGetters } from 'vuex'
import mobileICopySiderBar from "@/components/user/details/mamSub/ICopy/mobileICopySiderBar";
import {getStaus,getStyle} from "@/components/user/details/mamSub/ICopy/utils";
import rightContent from "@/components/user/details/mamSub/ICopy/rightContent";
import subManSliderBar from "@/components/user/details/mamSub/ICopy/subManSliderBar";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {removeSubscription} from "@/api/copy";
  export default {
    name: 'index',
    components:{
      VuePerfectScrollbar,
      subManSliderBar,
      rightContent,
      mobileICopySiderBar,
      searchTradeDialog,
    },
    data() {
      return {
        currentCycle: {
        },

        settings: {
          maxScrollbarLength : 60,
          wheelSpeed         : .60,
        },

        mobileDialogShow: false,

        searchDialogShow: false,
        hasOneActiveCopy: true,// 都效订阅
      };
    },
    computed:{
      ...mapGetters(['realMobile']),
      allNoOneActiveStyle(){
        return {
          backgroundColor: colorRgba('#F29132',0.1)
        }
      }
    },
    mounted(){
      let reouterview = document.getElementById('body');
      reouterview.classList.add('hidden-scroll');

      let wrapper = document.getElementById('contentwrapper');
      wrapper.classList.add('content-wrapper-special');
    },
    beforeDestroy(){
      let reouterview = document.getElementById('body');
      reouterview && reouterview.classList.remove('hidden-scroll');

      let wrapper = document.getElementById('contentwrapper');
      wrapper && wrapper.classList.remove('content-wrapper-special');
    },
    methods: {
      getStaus,
      getStyle,
      changeRefresh(){
        if(!this.realMobile){
          this.$refs.pcsliderbar.getData();
        }else {
          this.$refs.mobilesliderbar.$refs.siderbarinner.getData();
        }
      },
      acceptCurrentCycle(currentCycle){
        this.currentCycle = currentCycle;
      },
      mobileICopyHandle(){
        // 移动端
        this.mobileDialogShow = true;
      },
      // row数据要联调 todo
      editHandle(){
        this.$store.commit('setCurrentMasterMtId', this.currentCycle.masterMtId);
        this.$store.commit('setMamSubEditSubscrpitParams', {
          trusteeship: this.currentCycle.managementAmount,
          autoRenew: this.currentCycle.isRenew == 1 ? true : false,
          ids: this.currentCycle.subId,
          mamCopyLogin: this.currentCycle.copyLogin, // todo还差这个字段
          balance: this.currentCycle.copyBalance,
        });
        this.$store.commit('setMamSubAccountEditSubscrpitDialogShow', true);
      },
      cancleHandle(){
        this.$confirm(this.$t('mamCancleTips'), this.$t('socialSubCancelCopyButtonText'), {
          confirmButtonText: this.$t('root.confirm'),
          cancelButtonText: this.$t('root.cancle'),
          type: 'warning',
          customClass: 'self-messagebox-wrapper'
        }).then(() => {
          removeSubscription({
            id: this.currentCycle.subId,
            closeMode: 1
          }).then((res) => {
            this.$message({
              type: 'success',
              message: this.$t('cancleSuccess')
            });
            this.changeRefresh();
          })
        }).catch(() => {
          //几点取消的提示
        });
      },
      copyHandle(){
        this.$store.commit('setCurrentMasterMtId', this.currentCycle.masterMtId);
        this.$store.commit('setMamSubEditSubscrpitParams', {
          trusteeship: this.currentCycle.trusteeship,
          mamMt4: +this.$route.params.mtid,
          autoRenew: false,
        });
        this.$store.commit('setMamSubscrpitDialogShow', true);
      },
      notActiveHandle(){
        this.searchDialogShow = true;
      },
      acceptNoOneActive(flag){
        this.hasOneActiveCopy = flag;
      }
    }
  };
</script>

<style lang="scss" scoped>
.subscription {

    .view-box {
    }
  .pc-no-active-subscript {
    width: 100vw;
    height: 40px;
    line-height: 40px;
    color: #F29132;
    position: relative;
    top: -40px;
    left: -30px;
    padding-left: 30px;
  }
}
// pc端样式
@media screen and (min-width: 768px){
  .layout-under-content {
    &.notActive {
    }
  }
}
</style>
